import React, { Component } from "react";

class Resume extends Component {

  render() {
    if (!this.props.data) return null;

    return (
      <section id="resume">
          <div className="row education">
            <div className="three columns header-col">
              <h1>
                <span>Hardware</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">

                <div key="PCB">
                  <h3>PCB of the project</h3>
                  <img alt="" src="images/pcb.png"/>
                  <p>
                    The power is supplemented by the serial converter, no external power is required.
                  </p>
                </div>
                  
                <div key="reedMatrix">
                  <h3>Reed Matrix</h3>
                  <p>
                    As stated before, the matrix is composed by Reed switches and diodes:
                  </p>
                  <img alt="" src="images/reedMatrix.jpg"/>
                  <p>
                    To design the board, a replica of a reed switch with the area of activation was created using a multimeter:
                  </p>
                  <img alt="" src="images/img2.jpg"/>
                  <p>A wooden board was drilled to keep the switches in place, and everything was solded:</p>
                  <img alt="" src="images/img3.jpg"/>
                  <img alt="" src="images/img4.jpg"/>
                  <h6>Alternatives:</h6>
                  <p>Hall effect sensors can also be used, but due to the price and the uni-polarity detection they weren't used.</p>
                </div>

                <div key="ATMEGA">
                  <h3>ATMEGA</h3>
                  <p>
                    The ATMEGA168 acts as the main brain of the project. This is the pin layout:
                  </p>
                  <img alt="" src="images/connection.jpg"/>
                  <p>
                    All the calculations are done in the microprocessor using the custom chess library. The computer is just used as a way of displaying information.
                  </p>
                  <p>
                    A button is used as a way of indicating the end of the turn. The exact way of determining a move is described in the software part.
                  </p>
                  <h6>Alternatives:</h6>
                  <p>A demultiplexer could be used for the output pins, reducing this from 8 to 3, leaving some free pins for other uses</p>
                </div>
                
                <div key="Serial">
                  <h3>Serial to USB</h3>
                  <p>
                    The <a href="https://www.silabs.com/documents/public/data-sheets/CP2102-9.pdf">serial to USB converter CP2102</a> was used for the communication with the PC.
                    Due to the frequency of the microprocessor, the serial communcation can fail (Only 0.2%). 
                    This possibility of failure was taken in mind by developing a serial communication protocol, where this error can be detected and notified to the other part of the communication
                  </p>
                  <h6>Alternatives:</h6>
                  <p>Another cool way of communicating would be using bluetooth or a web server, but due to the added complication of this ways the serial-USB way was used</p>
                
                </div>

                </div>
              </div>
            </div>
          </div>

          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>Software</span>
              </h1>
            </div>

            <div className="nine columns main-col">

            <div key="main">
              <h3>Main program</h3>
              <p>
                As stated before, the microprocessor can only see if there is a piece in a square, not wich piece it is.
                All games start from the same position, so with some clever treatment of the data we can see where is wich piece and who moved.
                This main program of ATMEGA follows a very simple loop:
              </p>
              <img alt="" src="images/mainflow.png"/>
              <p>
                When an external interrupt happen (Some player pressed the turn button) the microprocessor starts another flowchart:
              </p>
              <img alt="" src="images/interruptflow.png"/>
              <p>
                Chess is a game full of edge cases and weird rules.
                To fully comprehend the way the custom library is built is recommended to read the files, as everything is commented there.
              </p>
            </div>

            <div key="tests">
              <h3>Tests</h3>
              <p>
                To ensure the correct working of the developed libraries, some functional tests were created using C.
                This tests use the custom library to play a predefined game, outputing some data about the state of it.
                They can be found in the file test.c
              </p>
            </div>

            <div key="communication.py">
              <h3>Communication with computer</h3>
              <p>
                communication.py is the program used to communicate with the microprocessor.
                It is a console program written for windows in python, that handles the communication with the project.
                It has to be said that the computer is used as a way of displaying things and showing the possible extension of this project.
                The main focus was the microprocessor, that's why this program is very rudimentary.
                We can select 2 gamemodes:
                <ul>
                  <li><b>• Normal game:</b> A normal chess game is recorded.</li>
                  <li><b>• Computer game:</b> A chess engine (Stockfish, one of the most powerful ones) is used to suggest moves at any point of the game. This mode is useful for analysis or single-play.</li>
                </ul>

                And we can select between 3 types of output:
                <ul>
                  <li><b>• Keyboard simulation:</b> All the moves will be pressed in your keyboard. The objective of this mode is running in the background and using other programs such as <a href="http://www.playwitharena.de/">Arena Chess Gui</a> with automatic inputs </li>
                  <li><b>• Show real time:</b> The state of the game is shown in real time in the terminal</li>
                  <li><b>• Save to file:</b> The game will be saved to a file for further analysis of it</li>
                </ul>

              </p>
            </div>

            <div key="debug.py">
              <h3>Debug mode</h3>
              <p>
                A debug mode has been implemented in the main program. It can be activated at the programming of the microchip,
                and by executing an special program in the PC (debug.py) it can be seen what the microprocessor is detecting.
                This program is also prepared to recieve any message, so a quick way of checking and debugging new features can be easily created.
              </p>
            </div>

            <div>
              <p>
                All the code can be found at the <a href="https://github.com/SrHeli0s/SmartChess">Github repository</a>
              </p>
            </div>
            </div>
          </div>
      </section>
    );
  }
}

export default Resume;
